import React from 'react';
import AltIso from 'alt/utils/AltIso';
import {Link} from 'react-router';
import imgResolver from '../utils/img-resolver';

import SeoActions from '../actions/SeoActions';
import connectToStores from 'alt/utils/connectToStores';
import CurrentUserStore from '../stores/CurrentUserStore';
import CurrentUserActions from '../actions/CurrentUserActions';
import LoginForm from '../forms/LoginForm';

import FbLogin from '../components/FbLogin';


@AltIso.define((props) => {
    return Promise.all([
        new Promise((resolve) => {
            SeoActions.pushTitle('Log In');
            resolve();
        }),
        CurrentUserStore.getCurrentUser()
    ]);
})

@connectToStores
class LoginView extends React.Component {

    componentDidMount() {
        if (this.props.params.token) {
            CurrentUserStore.activateUser(this.props.params.token);
        }
    }

    static getPropsFromStores() {
        return {
            userStore: CurrentUserStore.getState()
        };
    }

    static getStores() {
        return [CurrentUserStore];
    }

    getUser(){
        return this.props.userStore.profile;
    }

    doLogin(e) {
        if (e && e.preventDefault) {
            e.preventDefault();
        }

        const data = this.refs.form.getValue();
        const errors = this.refs.form.validate(true).errors;
        //var email = React.findDOMNode(this.refs.email).value.trim();
        //var password = React.findDOMNode(this.refs.password).value.trim();

        //console.log(email, password);

        if (errors) {
            CurrentUserActions.failLogin(errors);
        }

        if (data) {
            // Try to log the user in
            CurrentUserStore.login(data);
        }
    }

    render() {
        if (this.props.userStore.isAuthenticated === true && this.props.userStore.profile.profile.role === "none"){
            if (typeof window !== 'undefined'){
                window.location = '/signup';
            }
        }
        let message;
        if (Object.keys(this.props.query).length && this.props.query.action) {
            message = <p className="sign-up-message">Sign up successful! A link for activating your account has been emailed to you.</p>;
        }
        const loginData = this.props.user.loginError.loginData || {};
        const loginError = this.props.user.loginError;
        let activationEmail;

        if (loginError.error && loginError.error.nonFieldErrors.startsWith('Your account')) {
            activationEmail = loginData.email;
        }

        return (
            <div className="view-login maxwidth-wrapper">
                <div className="view-content">
                    <img className="site-logo" src={require('../styles/images/site-logo.svg')} alt="Gigpanel" />
                    <form className="whitebox login-form" onSubmit={this.doLogin.bind(this)}>
                        <h1>Customer log in</h1>
                        <FbLogin/>
                        <div className="separator">
                            <span>or</span>
                        </div>

                        <LoginForm ref="form" activationEmail={activationEmail} originalFormData={loginData} loginError={loginError} />

                        <button className="btn btn-orange form-control-submit">Log in</button>
                        {message}
                    </form>
                    <p className="forgot-password-cta"><Link to="forgotpassword">Forgot your password?</Link></p>
                    <p className="signup-cta">Don't have an account? <Link to="signup">Sign up</Link></p>
                </div>
            </div>
        );
    }
}

export default LoginView;



/** WEBPACK FOOTER **
 ** ./app/src/views/LoginView.js
 **/